<template>
  <div class="py-10 text-center">
    <div
      class="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-brand-50 dark:bg-brand-950/40"
      :class="{ 'animate-pulse': pulse }"
    >
      <UIcon
        name="i-heroicons-arrow-path"
        class="h-6 w-6 text-brand-600"
        :class="{ 'animate-spin': spin }"
      />
    </div>
    <p class="text-sm font-medium text-toned">{{ message }}</p>
    <p v-if="hint" class="mt-1 text-xs text-muted">{{ hint }}</p>
  </div>
</template>

<script setup lang="ts">
withDefaults(defineProps<{
  message?: string
  hint?: string
  spin?: boolean
  pulse?: boolean
}>(), {
  message: 'Se încarcă...',
  hint: '',
  spin: true,
  pulse: false,
})
</script>
